import React from 'react';
import badge from '../../../assets/images/birdify/google-play-badge-en.svg';

/**
 * The official, unmodified "Get it on Google Play" badge as a plain external link.
 * Google's badge rules (see src/assets/images/birdify/README.md): never edit or
 * recolour the artwork, at least 28px high, quarter-height clear space, solid
 * contrasting background. Sizing lives in `.apps-play-badge` rules.
 *
 * `size` is `lg` (3.5rem, product page) or `card` (3rem, portfolio card).
 */
export default function GooglePlayBadge({ href, appName, size = 'lg', onClick }) {
  return (
    <a
      className={`apps-play-badge${size === 'card' ? ' apps-play-badge--card' : ''}`}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      <img src={badge} width="239" height="71" alt={`Get ${appName} on Google Play`} />
    </a>
  );
}
